import React, { type FC, useEffect, useState } from "react";
import { useI18next } from "gatsby-plugin-react-i18next";

import OfferDetailDialog from "@components/website/offers/offer-detail-dialog";
import CookieType from "@constants/CookieType";
import type { Promo } from "@interfaces/Promo";
import { useConfigurationState } from "@stores/configuration";
import { fetchPromos, isPromotion, sortPromos } from "@utilities/promo";
import Cookies from "js-cookie";

const PromoAutoPopup: FC = () => {
  const { language } = useI18next();
  const configurationState = useConfigurationState();

  const [promo, setPromo] = useState<Promo | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchPromos(language)
      .then(list => {
        if (cancelled) return;
        const candidates = list.filter(isPromotion);
        const latest = sortPromos(candidates)[0];
        if (latest === undefined) return;

        const lastPromoId =
          configurationState.lastPromoId ||
          Cookies.get(CookieType.LAST_PROMO_ID);

        if (lastPromoId !== latest.id) {
          setPromo(latest);
          setIsOpen(true);
          configurationState.setLastPromoId(latest.id);
        }
      })
      .catch(() => {
        // Silent fail — the popup just doesn't show.
      });
    return () => {
      cancelled = true;
    };
  }, [language, configurationState.lastPromoId]);

  if (promo === null) return null;

  return (
    <OfferDetailDialog promo={promo} isOpen={isOpen} setIsOpen={setIsOpen} />
  );
};

export default PromoAutoPopup;
